import { CalculateResultsType, FleetDataType, payloadCalculateFootprint } from 'src/core/models'
import axios from 'axios'

export async function getFleetAPI(): Promise<FleetDataType[]> {
  const { data } = await axios.get(`api/v1/cabify/fleet/`)
  return data.results
}

export async function createOrEditFleetAPI(payload: FleetDataType, fleetId?: number): Promise<boolean> {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  const url = fleetId ? `/api/v1/cabify/fleet/${fleetId}/` : '/api/v1/cabify/fleet/'
  const { status } = await axios[fleetId ? 'put' : 'post'](url, payload, config)
  return status === 201 || status === 200
}

export async function deleteFleetAPI(fleetID: number): Promise<boolean> {
  const { status } = await axios.delete(`/api/v1/cabify/fleet/${fleetID}/`)
  return status === 204
}

export async function calculateFootprintAPI(payload: payloadCalculateFootprint): Promise<CalculateResultsType[]> {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  const { data } = await axios.post(`api/v1/cabify/calculate_footprints/cabify_calculate/`, payload, config)
  return data.data
}

export async function downloadFileAPI(resultsID: number): Promise<any> {
  const { data } = await axios.get(`api/v1/cabify/calculate_footprints/download_file/?results_id=${resultsID}`)
  return data
}
